<template>
  <div style="display:flex;">
    <div class="p-1 border border-dark column5" style="height: auto">
      {{ indexRow }}
    </div>
    <div
      class="p-1 border border-dark column45 col-nohover"
      style="height: auto"
    >
      {{ desc }}
    </div>
    <div class="p-1 border border-dark column50" style="height: auto">
      <div v-if="value && typeof value == 'string'">{{ value }}</div>
      <div v-else>
        <p v-for="(list, index) in value" :key="index * 4000">
          {{ index + 1 }}. {{ list.desc }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['indexRow', 'desc', 'value', 'is_bottom'],
}
</script>
